"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: identity/identity-check.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fidentity%2Fidentity-check.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.identityCheckServiceToJSON = exports.identityCheckServiceFromJSON = exports.identityCheckTypeToJSON = exports.identityCheckTypeFromJSON = exports.identityProviderToJSON = exports.identityProviderFromJSON = exports.identityFieldToJSON = exports.identityFieldFromJSON = exports.identityScoreToJSON = exports.identityScoreFromJSON = exports.identityScoreTypeToJSON = exports.identityScoreTypeFromJSON = exports.FieldVerificationAttempt = exports.Score = exports.ReasonCode = exports.IdentityCheck = exports.IdentityCheckService = exports.IdentityCheckType = exports.IdentityProvider = exports.IdentityField = exports.IdentityScore = exports.IdentityScoreType = void 0;
const decision_1 = require("./decision");
const protobufPackage = 'com.step.identity.proto';
var IdentityScoreType;
(function (IdentityScoreType) {
    IdentityScoreType["INVALID_IDENTITY_SCORE_TYPE"] = "INVALID_IDENTITY_SCORE_TYPE";
    /**
     * RISK - The score describes some aspect of the risk of the identity, either
     * overall or just a specific field of the identity
     */
    IdentityScoreType["RISK"] = "RISK";
    /**
     * MATCHING - The score describes how closely the provided value for the field
     * matches the expected identity
     */
    IdentityScoreType["MATCHING"] = "MATCHING";
    IdentityScoreType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(IdentityScoreType || (exports.IdentityScoreType = IdentityScoreType = {}));
/**
 * A score that is part of the result returned from an identity check service.
 */
var IdentityScore;
(function (IdentityScore) {
    IdentityScore["INVALID_IDENTITY_SCORE"] = "INVALID_IDENTITY_SCORE";
    IdentityScore["PAYFONE_TRUST_SCORE"] = "PAYFONE_TRUST_SCORE";
    IdentityScore["PAYFONE_FIRST_NAME_MATCH_SCORE"] = "PAYFONE_FIRST_NAME_MATCH_SCORE";
    IdentityScore["PAYFONE_LAST_NAME_MATCH_SCORE"] = "PAYFONE_LAST_NAME_MATCH_SCORE";
    IdentityScore["PAYFONE_NAME_MATCH_SCORE"] = "PAYFONE_NAME_MATCH_SCORE";
    IdentityScore["PAYFONE_STREET_NUMBER_MATCH_SCORE"] = "PAYFONE_STREET_NUMBER_MATCH_SCORE";
    IdentityScore["PAYFONE_ADDRESS_MATCH_SCORE"] = "PAYFONE_ADDRESS_MATCH_SCORE";
    IdentityScore["SOCURE_30_SIGMA_FRAUD_SCORE"] = "SOCURE_30_SIGMA_FRAUD_SCORE";
    IdentityScore["SOCURE_30_ADDRESS_MATCH_SCORE"] = "SOCURE_30_ADDRESS_MATCH_SCORE";
    IdentityScore["SOCURE_30_EMAIL_MATCH_SCORE"] = "SOCURE_30_EMAIL_MATCH_SCORE";
    IdentityScore["SOCURE_30_PHONE_MATCH_SCORE"] = "SOCURE_30_PHONE_MATCH_SCORE";
    IdentityScore["SOCURE_30_ADDRESS_RISK_SCORE"] = "SOCURE_30_ADDRESS_RISK_SCORE";
    IdentityScore["SOCURE_30_EMAIL_RISK_SCORE"] = "SOCURE_30_EMAIL_RISK_SCORE";
    IdentityScore["SOCURE_30_PHONE_RISK_SCORE"] = "SOCURE_30_PHONE_RISK_SCORE";
    IdentityScore["SENTILINK_ABUSE_SCORE"] = "SENTILINK_ABUSE_SCORE";
    IdentityScore["SENTILINK_FIRST_PARTY_SYNTHETIC_SCORE"] = "SENTILINK_FIRST_PARTY_SYNTHETIC_SCORE";
    IdentityScore["SENTILINK_ID_THEFT_SCORE"] = "SENTILINK_ID_THEFT_SCORE";
    IdentityScore["SENTILINK_THIRD_PARTY_SYNTHETIC_SCORE"] = "SENTILINK_THIRD_PARTY_SYNTHETIC_SCORE";
    IdentityScore["ID_ANALYTICS_ID_SCORE"] = "ID_ANALYTICS_ID_SCORE";
    IdentityScore["UNRECOGNIZED"] = "UNRECOGNIZED";
})(IdentityScore || (exports.IdentityScore = IdentityScore = {}));
var IdentityField;
(function (IdentityField) {
    IdentityField["INVALID_IDENTITY_SCORE_FIELD"] = "INVALID_IDENTITY_SCORE_FIELD";
    IdentityField["DOB"] = "DOB";
    IdentityField["FIRST_NAME"] = "FIRST_NAME";
    IdentityField["LAST_NAME"] = "LAST_NAME";
    IdentityField["LEGAL_NAME"] = "LEGAL_NAME";
    IdentityField["ADDRESS_LINE_1"] = "ADDRESS_LINE_1";
    IdentityField["ADDRESS_CITY"] = "ADDRESS_CITY";
    IdentityField["ADDRESS_STATE_PROVINCE_REGION"] = "ADDRESS_STATE_PROVINCE_REGION";
    IdentityField["ADDRESS_ZIP_POSTAL_CODE"] = "ADDRESS_ZIP_POSTAL_CODE";
    IdentityField["ADDRESS"] = "ADDRESS";
    IdentityField["SSN"] = "SSN";
    IdentityField["LAST_FOUR_SSN"] = "LAST_FOUR_SSN";
    IdentityField["EMAIL"] = "EMAIL";
    IdentityField["PHONE_NUMBER"] = "PHONE_NUMBER";
    IdentityField["UNRECOGNIZED"] = "UNRECOGNIZED";
})(IdentityField || (exports.IdentityField = IdentityField = {}));
var IdentityProvider;
(function (IdentityProvider) {
    IdentityProvider["INVALID_IDENTITY_PROVIDER"] = "INVALID_IDENTITY_PROVIDER";
    IdentityProvider["ALLOY"] = "ALLOY";
    IdentityProvider["BYPASS"] = "BYPASS";
    IdentityProvider["SIMULATE"] = "SIMULATE";
    IdentityProvider["ALLOY_JOURNEY"] = "ALLOY_JOURNEY";
    IdentityProvider["UNRECOGNIZED"] = "UNRECOGNIZED";
})(IdentityProvider || (exports.IdentityProvider = IdentityProvider = {}));
var IdentityCheckType;
(function (IdentityCheckType) {
    IdentityCheckType["INVALID_IDENTITY_CHECK_TYPE"] = "INVALID_IDENTITY_CHECK_TYPE";
    IdentityCheckType["ACCOUNT_CREATION"] = "ACCOUNT_CREATION";
    IdentityCheckType["KYC"] = "KYC";
    IdentityCheckType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(IdentityCheckType || (exports.IdentityCheckType = IdentityCheckType = {}));
/**
 * Services that provide some form of identity check, returning scores,
 * reason codes and additional data used for decisioning.
 */
var IdentityCheckService;
(function (IdentityCheckService) {
    IdentityCheckService["INVALID_IDENTITY_SERVICE_PROVIDER"] = "INVALID_IDENTITY_SERVICE_PROVIDER";
    IdentityCheckService["HISTORICAL_PAYFONE_IDENTITY_VERIFY"] = "HISTORICAL_PAYFONE_IDENTITY_VERIFY";
    IdentityCheckService["HISTORICAL_PAYFONE_TRUST_SCORE"] = "HISTORICAL_PAYFONE_TRUST_SCORE";
    IdentityCheckService["ID_ANALYTICS_ID_SCORE_SERVICE"] = "ID_ANALYTICS_ID_SCORE_SERVICE";
    IdentityCheckService["IDOLOGY_EXPECT_ID_SERVICE"] = "IDOLOGY_EXPECT_ID_SERVICE";
    IdentityCheckService["PAYFONE_IDENTITY_VERIFY_SERVICE"] = "PAYFONE_IDENTITY_VERIFY_SERVICE";
    IdentityCheckService["PAYFONE_TRUST_SCORE_SERVICE"] = "PAYFONE_TRUST_SCORE_SERVICE";
    IdentityCheckService["SENTILINK_SERVICE"] = "SENTILINK_SERVICE";
    IdentityCheckService["SENTILINK_COMPLETE_SERVICE"] = "SENTILINK_COMPLETE_SERVICE";
    IdentityCheckService["SOCURE_30_SERVICE"] = "SOCURE_30_SERVICE";
    IdentityCheckService["SENTILINK_ECBSV"] = "SENTILINK_ECBSV";
    IdentityCheckService["UNRECOGNIZED"] = "UNRECOGNIZED";
})(IdentityCheckService || (exports.IdentityCheckService = IdentityCheckService = {}));
function createBaseIdentityCheck() {
    return {
        userId: '',
        provider: IdentityProvider.INVALID_IDENTITY_PROVIDER,
        type: IdentityCheckType.INVALID_IDENTITY_CHECK_TYPE,
        decision: decision_1.Decision.INVALID_RESULT,
        createdAtMs: '0',
        referenceId: '',
        reasonCodes: [],
        scores: [],
        fieldVerificationAttempts: [],
        tags: [],
    };
}
exports.IdentityCheck = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            provider: isSet(object.provider)
                ? identityProviderFromJSON(object.provider)
                : IdentityProvider.INVALID_IDENTITY_PROVIDER,
            type: isSet(object.type)
                ? identityCheckTypeFromJSON(object.type)
                : IdentityCheckType.INVALID_IDENTITY_CHECK_TYPE,
            decision: isSet(object.decision)
                ? (0, decision_1.decisionFromJSON)(object.decision)
                : decision_1.Decision.INVALID_RESULT,
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
            referenceId: isSet(object.referenceId) ? globalThis.String(object.referenceId) : '',
            reasonCodes: globalThis.Array.isArray(object?.reasonCodes)
                ? object.reasonCodes.map((e) => exports.ReasonCode.fromJSON(e))
                : [],
            scores: globalThis.Array.isArray(object?.scores)
                ? object.scores.map((e) => exports.Score.fromJSON(e))
                : [],
            fieldVerificationAttempts: globalThis.Array.isArray(object?.fieldVerificationAttempts)
                ? object.fieldVerificationAttempts.map((e) => exports.FieldVerificationAttempt.fromJSON(e))
                : [],
            tags: globalThis.Array.isArray(object?.tags)
                ? object.tags.map((e) => globalThis.String(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.provider !== IdentityProvider.INVALID_IDENTITY_PROVIDER) {
            obj.provider = identityProviderToJSON(message.provider);
        }
        if (message.type !== IdentityCheckType.INVALID_IDENTITY_CHECK_TYPE) {
            obj.type = identityCheckTypeToJSON(message.type);
        }
        if (message.decision !== decision_1.Decision.INVALID_RESULT) {
            obj.decision = (0, decision_1.decisionToJSON)(message.decision);
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        if (message.reasonCodes?.length) {
            obj.reasonCodes = message.reasonCodes.map((e) => exports.ReasonCode.toJSON(e));
        }
        if (message.scores?.length) {
            obj.scores = message.scores.map((e) => exports.Score.toJSON(e));
        }
        if (message.fieldVerificationAttempts?.length) {
            obj.fieldVerificationAttempts = message.fieldVerificationAttempts.map((e) => exports.FieldVerificationAttempt.toJSON(e));
        }
        if (message.tags?.length) {
            obj.tags = message.tags;
        }
        return obj;
    },
    create(base) {
        return exports.IdentityCheck.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIdentityCheck();
        message.userId = object.userId ?? '';
        message.provider = object.provider ?? IdentityProvider.INVALID_IDENTITY_PROVIDER;
        message.type = object.type ?? IdentityCheckType.INVALID_IDENTITY_CHECK_TYPE;
        message.decision = object.decision ?? decision_1.Decision.INVALID_RESULT;
        message.createdAtMs = object.createdAtMs ?? '0';
        message.referenceId = object.referenceId ?? '';
        message.reasonCodes = object.reasonCodes?.map((e) => exports.ReasonCode.fromPartial(e)) || [];
        message.scores = object.scores?.map((e) => exports.Score.fromPartial(e)) || [];
        message.fieldVerificationAttempts =
            object.fieldVerificationAttempts?.map((e) => exports.FieldVerificationAttempt.fromPartial(e)) || [];
        message.tags = object.tags?.map((e) => e) || [];
        return message;
    },
};
function createBaseReasonCode() {
    return { service: IdentityCheckService.INVALID_IDENTITY_SERVICE_PROVIDER, code: '' };
}
exports.ReasonCode = {
    fromJSON(object) {
        const message = {
            service: isSet(object.service)
                ? identityCheckServiceFromJSON(object.service)
                : IdentityCheckService.INVALID_IDENTITY_SERVICE_PROVIDER,
            code: isSet(object.code) ? globalThis.String(object.code) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.service !== IdentityCheckService.INVALID_IDENTITY_SERVICE_PROVIDER) {
            obj.service = identityCheckServiceToJSON(message.service);
        }
        if (message.code !== '') {
            obj.code = message.code;
        }
        return obj;
    },
    create(base) {
        return exports.ReasonCode.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReasonCode();
        message.service = object.service ?? IdentityCheckService.INVALID_IDENTITY_SERVICE_PROVIDER;
        message.code = object.code ?? '';
        return message;
    },
};
function createBaseScore() {
    return {
        service: IdentityCheckService.INVALID_IDENTITY_SERVICE_PROVIDER,
        score: IdentityScore.INVALID_IDENTITY_SCORE,
        type: IdentityScoreType.INVALID_IDENTITY_SCORE_TYPE,
        field: IdentityField.INVALID_IDENTITY_SCORE_FIELD,
        value: 0,
    };
}
exports.Score = {
    fromJSON(object) {
        const message = {
            service: isSet(object.service)
                ? identityCheckServiceFromJSON(object.service)
                : IdentityCheckService.INVALID_IDENTITY_SERVICE_PROVIDER,
            score: isSet(object.score)
                ? identityScoreFromJSON(object.score)
                : IdentityScore.INVALID_IDENTITY_SCORE,
            type: isSet(object.type)
                ? identityScoreTypeFromJSON(object.type)
                : IdentityScoreType.INVALID_IDENTITY_SCORE_TYPE,
            value: isSet(object.value) ? globalThis.Number(object.value) : 0,
        };
        if (isSet(object.field)) {
            message.field = identityFieldFromJSON(object.field);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.service !== IdentityCheckService.INVALID_IDENTITY_SERVICE_PROVIDER) {
            obj.service = identityCheckServiceToJSON(message.service);
        }
        if (message.score !== IdentityScore.INVALID_IDENTITY_SCORE) {
            obj.score = identityScoreToJSON(message.score);
        }
        if (message.type !== IdentityScoreType.INVALID_IDENTITY_SCORE_TYPE) {
            obj.type = identityScoreTypeToJSON(message.type);
        }
        if (message.field !== undefined && message.field !== IdentityField.INVALID_IDENTITY_SCORE_FIELD) {
            obj.field = identityFieldToJSON(message.field);
        }
        if (message.value !== 0) {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.Score.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseScore();
        message.service = object.service ?? IdentityCheckService.INVALID_IDENTITY_SERVICE_PROVIDER;
        message.score = object.score ?? IdentityScore.INVALID_IDENTITY_SCORE;
        message.type = object.type ?? IdentityScoreType.INVALID_IDENTITY_SCORE_TYPE;
        message.field = object.field ?? IdentityField.INVALID_IDENTITY_SCORE_FIELD;
        message.value = object.value ?? 0;
        return message;
    },
};
function createBaseFieldVerificationAttempt() {
    return {
        service: IdentityCheckService.INVALID_IDENTITY_SERVICE_PROVIDER,
        field: IdentityField.INVALID_IDENTITY_SCORE_FIELD,
        verified: false,
    };
}
exports.FieldVerificationAttempt = {
    fromJSON(object) {
        const message = {
            service: isSet(object.service)
                ? identityCheckServiceFromJSON(object.service)
                : IdentityCheckService.INVALID_IDENTITY_SERVICE_PROVIDER,
            field: isSet(object.field)
                ? identityFieldFromJSON(object.field)
                : IdentityField.INVALID_IDENTITY_SCORE_FIELD,
            verified: isSet(object.verified) ? globalThis.Boolean(object.verified) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.service !== IdentityCheckService.INVALID_IDENTITY_SERVICE_PROVIDER) {
            obj.service = identityCheckServiceToJSON(message.service);
        }
        if (message.field !== IdentityField.INVALID_IDENTITY_SCORE_FIELD) {
            obj.field = identityFieldToJSON(message.field);
        }
        if (message.verified !== false) {
            obj.verified = message.verified;
        }
        return obj;
    },
    create(base) {
        return exports.FieldVerificationAttempt.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFieldVerificationAttempt();
        message.service = object.service ?? IdentityCheckService.INVALID_IDENTITY_SERVICE_PROVIDER;
        message.field = object.field ?? IdentityField.INVALID_IDENTITY_SCORE_FIELD;
        message.verified = object.verified ?? false;
        return message;
    },
};
function identityScoreTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_IDENTITY_SCORE_TYPE':
            return IdentityScoreType.INVALID_IDENTITY_SCORE_TYPE;
        case 1:
        case 'RISK':
            return IdentityScoreType.RISK;
        case 2:
        case 'MATCHING':
            return IdentityScoreType.MATCHING;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return IdentityScoreType.UNRECOGNIZED;
    }
}
exports.identityScoreTypeFromJSON = identityScoreTypeFromJSON;
function identityScoreTypeToJSON(object) {
    switch (object) {
        case IdentityScoreType.INVALID_IDENTITY_SCORE_TYPE:
            return 'INVALID_IDENTITY_SCORE_TYPE';
        case IdentityScoreType.RISK:
            return 'RISK';
        case IdentityScoreType.MATCHING:
            return 'MATCHING';
        case IdentityScoreType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.identityScoreTypeToJSON = identityScoreTypeToJSON;
function identityScoreFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_IDENTITY_SCORE':
            return IdentityScore.INVALID_IDENTITY_SCORE;
        case 1:
        case 'PAYFONE_TRUST_SCORE':
            return IdentityScore.PAYFONE_TRUST_SCORE;
        case 8:
        case 'PAYFONE_FIRST_NAME_MATCH_SCORE':
            return IdentityScore.PAYFONE_FIRST_NAME_MATCH_SCORE;
        case 9:
        case 'PAYFONE_LAST_NAME_MATCH_SCORE':
            return IdentityScore.PAYFONE_LAST_NAME_MATCH_SCORE;
        case 10:
        case 'PAYFONE_NAME_MATCH_SCORE':
            return IdentityScore.PAYFONE_NAME_MATCH_SCORE;
        case 11:
        case 'PAYFONE_STREET_NUMBER_MATCH_SCORE':
            return IdentityScore.PAYFONE_STREET_NUMBER_MATCH_SCORE;
        case 12:
        case 'PAYFONE_ADDRESS_MATCH_SCORE':
            return IdentityScore.PAYFONE_ADDRESS_MATCH_SCORE;
        case 2:
        case 'SOCURE_30_SIGMA_FRAUD_SCORE':
            return IdentityScore.SOCURE_30_SIGMA_FRAUD_SCORE;
        case 13:
        case 'SOCURE_30_ADDRESS_MATCH_SCORE':
            return IdentityScore.SOCURE_30_ADDRESS_MATCH_SCORE;
        case 14:
        case 'SOCURE_30_EMAIL_MATCH_SCORE':
            return IdentityScore.SOCURE_30_EMAIL_MATCH_SCORE;
        case 15:
        case 'SOCURE_30_PHONE_MATCH_SCORE':
            return IdentityScore.SOCURE_30_PHONE_MATCH_SCORE;
        case 16:
        case 'SOCURE_30_ADDRESS_RISK_SCORE':
            return IdentityScore.SOCURE_30_ADDRESS_RISK_SCORE;
        case 17:
        case 'SOCURE_30_EMAIL_RISK_SCORE':
            return IdentityScore.SOCURE_30_EMAIL_RISK_SCORE;
        case 18:
        case 'SOCURE_30_PHONE_RISK_SCORE':
            return IdentityScore.SOCURE_30_PHONE_RISK_SCORE;
        case 3:
        case 'SENTILINK_ABUSE_SCORE':
            return IdentityScore.SENTILINK_ABUSE_SCORE;
        case 4:
        case 'SENTILINK_FIRST_PARTY_SYNTHETIC_SCORE':
            return IdentityScore.SENTILINK_FIRST_PARTY_SYNTHETIC_SCORE;
        case 5:
        case 'SENTILINK_ID_THEFT_SCORE':
            return IdentityScore.SENTILINK_ID_THEFT_SCORE;
        case 6:
        case 'SENTILINK_THIRD_PARTY_SYNTHETIC_SCORE':
            return IdentityScore.SENTILINK_THIRD_PARTY_SYNTHETIC_SCORE;
        case 7:
        case 'ID_ANALYTICS_ID_SCORE':
            return IdentityScore.ID_ANALYTICS_ID_SCORE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return IdentityScore.UNRECOGNIZED;
    }
}
exports.identityScoreFromJSON = identityScoreFromJSON;
function identityScoreToJSON(object) {
    switch (object) {
        case IdentityScore.INVALID_IDENTITY_SCORE:
            return 'INVALID_IDENTITY_SCORE';
        case IdentityScore.PAYFONE_TRUST_SCORE:
            return 'PAYFONE_TRUST_SCORE';
        case IdentityScore.PAYFONE_FIRST_NAME_MATCH_SCORE:
            return 'PAYFONE_FIRST_NAME_MATCH_SCORE';
        case IdentityScore.PAYFONE_LAST_NAME_MATCH_SCORE:
            return 'PAYFONE_LAST_NAME_MATCH_SCORE';
        case IdentityScore.PAYFONE_NAME_MATCH_SCORE:
            return 'PAYFONE_NAME_MATCH_SCORE';
        case IdentityScore.PAYFONE_STREET_NUMBER_MATCH_SCORE:
            return 'PAYFONE_STREET_NUMBER_MATCH_SCORE';
        case IdentityScore.PAYFONE_ADDRESS_MATCH_SCORE:
            return 'PAYFONE_ADDRESS_MATCH_SCORE';
        case IdentityScore.SOCURE_30_SIGMA_FRAUD_SCORE:
            return 'SOCURE_30_SIGMA_FRAUD_SCORE';
        case IdentityScore.SOCURE_30_ADDRESS_MATCH_SCORE:
            return 'SOCURE_30_ADDRESS_MATCH_SCORE';
        case IdentityScore.SOCURE_30_EMAIL_MATCH_SCORE:
            return 'SOCURE_30_EMAIL_MATCH_SCORE';
        case IdentityScore.SOCURE_30_PHONE_MATCH_SCORE:
            return 'SOCURE_30_PHONE_MATCH_SCORE';
        case IdentityScore.SOCURE_30_ADDRESS_RISK_SCORE:
            return 'SOCURE_30_ADDRESS_RISK_SCORE';
        case IdentityScore.SOCURE_30_EMAIL_RISK_SCORE:
            return 'SOCURE_30_EMAIL_RISK_SCORE';
        case IdentityScore.SOCURE_30_PHONE_RISK_SCORE:
            return 'SOCURE_30_PHONE_RISK_SCORE';
        case IdentityScore.SENTILINK_ABUSE_SCORE:
            return 'SENTILINK_ABUSE_SCORE';
        case IdentityScore.SENTILINK_FIRST_PARTY_SYNTHETIC_SCORE:
            return 'SENTILINK_FIRST_PARTY_SYNTHETIC_SCORE';
        case IdentityScore.SENTILINK_ID_THEFT_SCORE:
            return 'SENTILINK_ID_THEFT_SCORE';
        case IdentityScore.SENTILINK_THIRD_PARTY_SYNTHETIC_SCORE:
            return 'SENTILINK_THIRD_PARTY_SYNTHETIC_SCORE';
        case IdentityScore.ID_ANALYTICS_ID_SCORE:
            return 'ID_ANALYTICS_ID_SCORE';
        case IdentityScore.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.identityScoreToJSON = identityScoreToJSON;
function identityFieldFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_IDENTITY_SCORE_FIELD':
            return IdentityField.INVALID_IDENTITY_SCORE_FIELD;
        case 1:
        case 'DOB':
            return IdentityField.DOB;
        case 2:
        case 'FIRST_NAME':
            return IdentityField.FIRST_NAME;
        case 3:
        case 'LAST_NAME':
            return IdentityField.LAST_NAME;
        case 4:
        case 'LEGAL_NAME':
            return IdentityField.LEGAL_NAME;
        case 5:
        case 'ADDRESS_LINE_1':
            return IdentityField.ADDRESS_LINE_1;
        case 6:
        case 'ADDRESS_CITY':
            return IdentityField.ADDRESS_CITY;
        case 7:
        case 'ADDRESS_STATE_PROVINCE_REGION':
            return IdentityField.ADDRESS_STATE_PROVINCE_REGION;
        case 8:
        case 'ADDRESS_ZIP_POSTAL_CODE':
            return IdentityField.ADDRESS_ZIP_POSTAL_CODE;
        case 9:
        case 'ADDRESS':
            return IdentityField.ADDRESS;
        case 10:
        case 'SSN':
            return IdentityField.SSN;
        case 11:
        case 'LAST_FOUR_SSN':
            return IdentityField.LAST_FOUR_SSN;
        case 12:
        case 'EMAIL':
            return IdentityField.EMAIL;
        case 13:
        case 'PHONE_NUMBER':
            return IdentityField.PHONE_NUMBER;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return IdentityField.UNRECOGNIZED;
    }
}
exports.identityFieldFromJSON = identityFieldFromJSON;
function identityFieldToJSON(object) {
    switch (object) {
        case IdentityField.INVALID_IDENTITY_SCORE_FIELD:
            return 'INVALID_IDENTITY_SCORE_FIELD';
        case IdentityField.DOB:
            return 'DOB';
        case IdentityField.FIRST_NAME:
            return 'FIRST_NAME';
        case IdentityField.LAST_NAME:
            return 'LAST_NAME';
        case IdentityField.LEGAL_NAME:
            return 'LEGAL_NAME';
        case IdentityField.ADDRESS_LINE_1:
            return 'ADDRESS_LINE_1';
        case IdentityField.ADDRESS_CITY:
            return 'ADDRESS_CITY';
        case IdentityField.ADDRESS_STATE_PROVINCE_REGION:
            return 'ADDRESS_STATE_PROVINCE_REGION';
        case IdentityField.ADDRESS_ZIP_POSTAL_CODE:
            return 'ADDRESS_ZIP_POSTAL_CODE';
        case IdentityField.ADDRESS:
            return 'ADDRESS';
        case IdentityField.SSN:
            return 'SSN';
        case IdentityField.LAST_FOUR_SSN:
            return 'LAST_FOUR_SSN';
        case IdentityField.EMAIL:
            return 'EMAIL';
        case IdentityField.PHONE_NUMBER:
            return 'PHONE_NUMBER';
        case IdentityField.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.identityFieldToJSON = identityFieldToJSON;
function identityProviderFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_IDENTITY_PROVIDER':
            return IdentityProvider.INVALID_IDENTITY_PROVIDER;
        case 1:
        case 'ALLOY':
            return IdentityProvider.ALLOY;
        case 2:
        case 'BYPASS':
            return IdentityProvider.BYPASS;
        case 3:
        case 'SIMULATE':
            return IdentityProvider.SIMULATE;
        case 4:
        case 'ALLOY_JOURNEY':
            return IdentityProvider.ALLOY_JOURNEY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return IdentityProvider.UNRECOGNIZED;
    }
}
exports.identityProviderFromJSON = identityProviderFromJSON;
function identityProviderToJSON(object) {
    switch (object) {
        case IdentityProvider.INVALID_IDENTITY_PROVIDER:
            return 'INVALID_IDENTITY_PROVIDER';
        case IdentityProvider.ALLOY:
            return 'ALLOY';
        case IdentityProvider.BYPASS:
            return 'BYPASS';
        case IdentityProvider.SIMULATE:
            return 'SIMULATE';
        case IdentityProvider.ALLOY_JOURNEY:
            return 'ALLOY_JOURNEY';
        case IdentityProvider.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.identityProviderToJSON = identityProviderToJSON;
function identityCheckTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_IDENTITY_CHECK_TYPE':
            return IdentityCheckType.INVALID_IDENTITY_CHECK_TYPE;
        case 1:
        case 'ACCOUNT_CREATION':
            return IdentityCheckType.ACCOUNT_CREATION;
        case 2:
        case 'KYC':
            return IdentityCheckType.KYC;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return IdentityCheckType.UNRECOGNIZED;
    }
}
exports.identityCheckTypeFromJSON = identityCheckTypeFromJSON;
function identityCheckTypeToJSON(object) {
    switch (object) {
        case IdentityCheckType.INVALID_IDENTITY_CHECK_TYPE:
            return 'INVALID_IDENTITY_CHECK_TYPE';
        case IdentityCheckType.ACCOUNT_CREATION:
            return 'ACCOUNT_CREATION';
        case IdentityCheckType.KYC:
            return 'KYC';
        case IdentityCheckType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.identityCheckTypeToJSON = identityCheckTypeToJSON;
function identityCheckServiceFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_IDENTITY_SERVICE_PROVIDER':
            return IdentityCheckService.INVALID_IDENTITY_SERVICE_PROVIDER;
        case 1:
        case 'HISTORICAL_PAYFONE_IDENTITY_VERIFY':
            return IdentityCheckService.HISTORICAL_PAYFONE_IDENTITY_VERIFY;
        case 2:
        case 'HISTORICAL_PAYFONE_TRUST_SCORE':
            return IdentityCheckService.HISTORICAL_PAYFONE_TRUST_SCORE;
        case 3:
        case 'ID_ANALYTICS_ID_SCORE_SERVICE':
            return IdentityCheckService.ID_ANALYTICS_ID_SCORE_SERVICE;
        case 4:
        case 'IDOLOGY_EXPECT_ID_SERVICE':
            return IdentityCheckService.IDOLOGY_EXPECT_ID_SERVICE;
        case 5:
        case 'PAYFONE_IDENTITY_VERIFY_SERVICE':
            return IdentityCheckService.PAYFONE_IDENTITY_VERIFY_SERVICE;
        case 6:
        case 'PAYFONE_TRUST_SCORE_SERVICE':
            return IdentityCheckService.PAYFONE_TRUST_SCORE_SERVICE;
        case 7:
        case 'SENTILINK_SERVICE':
            return IdentityCheckService.SENTILINK_SERVICE;
        case 8:
        case 'SENTILINK_COMPLETE_SERVICE':
            return IdentityCheckService.SENTILINK_COMPLETE_SERVICE;
        case 9:
        case 'SOCURE_30_SERVICE':
            return IdentityCheckService.SOCURE_30_SERVICE;
        case 10:
        case 'SENTILINK_ECBSV':
            return IdentityCheckService.SENTILINK_ECBSV;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return IdentityCheckService.UNRECOGNIZED;
    }
}
exports.identityCheckServiceFromJSON = identityCheckServiceFromJSON;
function identityCheckServiceToJSON(object) {
    switch (object) {
        case IdentityCheckService.INVALID_IDENTITY_SERVICE_PROVIDER:
            return 'INVALID_IDENTITY_SERVICE_PROVIDER';
        case IdentityCheckService.HISTORICAL_PAYFONE_IDENTITY_VERIFY:
            return 'HISTORICAL_PAYFONE_IDENTITY_VERIFY';
        case IdentityCheckService.HISTORICAL_PAYFONE_TRUST_SCORE:
            return 'HISTORICAL_PAYFONE_TRUST_SCORE';
        case IdentityCheckService.ID_ANALYTICS_ID_SCORE_SERVICE:
            return 'ID_ANALYTICS_ID_SCORE_SERVICE';
        case IdentityCheckService.IDOLOGY_EXPECT_ID_SERVICE:
            return 'IDOLOGY_EXPECT_ID_SERVICE';
        case IdentityCheckService.PAYFONE_IDENTITY_VERIFY_SERVICE:
            return 'PAYFONE_IDENTITY_VERIFY_SERVICE';
        case IdentityCheckService.PAYFONE_TRUST_SCORE_SERVICE:
            return 'PAYFONE_TRUST_SCORE_SERVICE';
        case IdentityCheckService.SENTILINK_SERVICE:
            return 'SENTILINK_SERVICE';
        case IdentityCheckService.SENTILINK_COMPLETE_SERVICE:
            return 'SENTILINK_COMPLETE_SERVICE';
        case IdentityCheckService.SOCURE_30_SERVICE:
            return 'SOCURE_30_SERVICE';
        case IdentityCheckService.SENTILINK_ECBSV:
            return 'SENTILINK_ECBSV';
        case IdentityCheckService.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.identityCheckServiceToJSON = identityCheckServiceToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=identity-check.js.map